import * as React from 'react';
import * as classNames from 'classnames';
import { inputContent } from '../../../content/content';
import { DataTestObject, renderDataTest } from '../../../utilities/testAutomation';

interface TextInputProps {
  error?: string | false;
  addon?: Addon;
  hideAddon?: boolean;
  placeholder?: string;
  onChange: (e: React.ChangeEvent<any>) => void;
  dataTest?: DataTestObject;
}

export enum Addon {
  Pound = '£',
  Percentage = '%',
}

const parseDecimals = (value: string) => {
  if (/^\d+\.{0,1}\d{0,2}?$/.test(value)) {
    return value;
  }
  return (Math.trunc(Number(value) * 100) / 100) || value;
};

const TextInput = ({
  error,
  addon,
  onChange,
  hideAddon,
  placeholder,
  dataTest,
  ...rest
}: TextInputProps) => {
  const inputDataTest = dataTest && renderDataTest(dataTest.isTesting)(dataTest.tag);
  const errorDataTest = dataTest && renderDataTest(dataTest.isTesting)(`${dataTest.tag}-error`);

  return (
    <div className={classNames('input-wrapper', { 'has-error': !!error })}>
      <div className="input text-input">
        <div className={classNames('addon-wrapper', { 'no-addon': hideAddon })}>
          <input
            type="number"
            {...rest}
            placeholder={placeholder || inputContent.textInputPlaceholder}
            min="0"
            onChange={(e: React.ChangeEvent<any>) => {
              const { value } = e.target;
              e.target.value = parseDecimals(value);
              onChange(e);
            }}
            {...inputDataTest}
          />
          {!hideAddon && <span className="addon">{addon || '£'}</span>}
        </div>
        <div className="error-text" {...errorDataTest}>{error}</div>
      </div>
    </div>
  );
};

export default TextInput;



// WEBPACK FOOTER //
// ./src/components/Inputs/TextInput/TextInput.tsx